import { getMessages } from '../../../../../../../../store/constants';

export const BOARD_CUSTOM_ADD = getMessages().getText('card_form_custom_add');
export const BOARD_SECTION_CUSTOM = getMessages().getText('board_settings.card_custom_properties.title');
export const BOARD_SECTION_CUSTOM_SECTION_NEW = getMessages().getText('card_form_custom_section_new');
export const BOARD_CUSTOM_CANCEL = getMessages().getText('common.cancel');
export const BOARD_CUSTOM_EDIT = getMessages().getText('common.edit');
export const BOARD_SECTION_CUSTOM_PROPERTIES_TEXT = getMessages().getText('board_settings.card_custom_properties.text');
